import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useParams } from 'react-router';

import { apiClient } from '../api-client.ts';

export const useDeleteNamePattern = () => {
  const { projectId } = useParams();
  const queryClient = useQueryClient();

  return useMutation<void, Error, string>({
    mutationFn: (uuid) => apiClient.delete(`/v1/projects/${projectId}/name-patterns/${uuid}`),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['name-patterns', projectId] });
    },
  });
};
